import { useTranslation } from 'react-i18next';
import { css } from '@emotion/react';
import { BaseIcon as PlayerIcon, tokens } from '@hotjar/hotsauce';
import { SessionEndedButton } from './SessionEndedButton';

interface DeleteButtonProps {
  onClick: () => void;
  disabled: boolean;
}

export const DeleteButton = ({ onClick, disabled }: DeleteButtonProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <SessionEndedButton spacing={28} onClick={onClick} disabled={disabled}>
      <PlayerIcon
        css={css`
          color: ${tokens.color.white};
          margin-right: 10px;
        `}
        icon="trash"
        pixelSize={24}
      />
      {t('common:player.shortcuts.delete')}
    </SessionEndedButton>
  );
};
